/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createInvoiceFromDiscriminatorValue, createValidationProblemDetailsFromDiscriminatorValue, serializeInvoice, serializeInvoiceCreateRequest, type Invoice, type InvoiceCreateRequest, type ValidationProblemDetails } from '../models/index.js';
// @ts-ignore
import { DownloadRequestBuilderNavigationMetadata, type DownloadRequestBuilder } from './download/index.js';
// @ts-ignore
import { DownloadCombinedRequestBuilderRequestsMetadata, type DownloadCombinedRequestBuilder } from './downloadCombined/index.js';
// @ts-ignore
import { InvoiceItemRequestBuilderRequestsMetadata, type InvoiceItemRequestBuilder } from './item/index.js';
// @ts-ignore
import { SimulateRequestBuilderRequestsMetadata, type SimulateRequestBuilder } from './simulate/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /Invoice
 */
export interface InvoiceRequestBuilder extends BaseRequestBuilder<InvoiceRequestBuilder> {
    /**
     * The Download property
     */
    get download(): DownloadRequestBuilder;
    /**
     * The DownloadCombined property
     */
    get downloadCombined(): DownloadCombinedRequestBuilder;
    /**
     * The Simulate property
     */
    get simulate(): SimulateRequestBuilder;
    /**
     * Gets an item from the ApiSdk.Invoice.item collection
     * @param id Unique identifier of the item
     * @returns {InvoiceItemRequestBuilder}
     */
     byId(id: number) : InvoiceItemRequestBuilder;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<Invoice[]>}
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<Invoice[] | undefined>;
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<Invoice>}
     * @throws {ValidationProblemDetails} error when the service returns a 400 status code
     */
     post(body: InvoiceCreateRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<Invoice | undefined>;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: InvoiceCreateRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const InvoiceRequestBuilderUriTemplate = "{+baseurl}/Invoice";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const InvoiceRequestBuilderNavigationMetadata: Record<Exclude<keyof InvoiceRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    byId: {
        requestsMetadata: InvoiceItemRequestBuilderRequestsMetadata,
        pathParametersMappings: ["id"],
    },
    download: {
        navigationMetadata: DownloadRequestBuilderNavigationMetadata,
    },
    downloadCombined: {
        requestsMetadata: DownloadCombinedRequestBuilderRequestsMetadata,
    },
    simulate: {
        requestsMetadata: SimulateRequestBuilderRequestsMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const InvoiceRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: InvoiceRequestBuilderUriTemplate,
        responseBodyContentType: "text/plain;q=0.9",
        adapterMethodName: "sendCollection",
        responseBodyFactory:  createInvoiceFromDiscriminatorValue,
    },
    post: {
        uriTemplate: InvoiceRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createValidationProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createInvoiceFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeInvoiceCreateRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
